module.exports = __webpack_public_path__ + "static/img/viral_02.d601115d.jpg";